import React, { useEffect, useState, useCallback } from "react";

export const ResizableVerticalDivider = ({
  minSize = 10,
  maxSize = 90,
  onResize,
  onDoubleClick,
}) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    e.preventDefault();
  };

  const handleMouseMove = useCallback((e) => {
    if (isDragging) {
      const containerWidth = window.innerWidth;
      const newWidth = (e.clientX / containerWidth) * 100;
      onResize(Math.max(minSize, Math.min(maxSize, newWidth)));
    }
  }, [isDragging, onResize, minSize, maxSize]);

  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, []);

  useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging, handleMouseMove, handleMouseUp]);

  return (
    <div
      className="w-[2px] bg-gray-700 cursor-ew-resize h-full"
      onMouseDown={handleMouseDown}
      onDoubleClick={onDoubleClick}
    />
  );
};